"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.regexp.replace.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _excluded = ["children", "isNum"];

var _this = void 0;

var Text = function Text(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var children = _ref.children,
      isNum = _ref.isNum,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  // 识别并转换数字，如 10000元 -> 10,000元
  if (isNum && (0, _isString2["default"])(children)) {
    children = children.replace(/\d+/gm, function (num) {
      (0, _newArrowCheck2["default"])(this, _this2);
      return num.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    }.bind(this));
  }

  return /*#__PURE__*/_react["default"].createElement(_style.StyledTag, (0, _extends2["default"])({
    isNum: isNum
  }, others), children);
}.bind(void 0);

Text.propTypes = {
  /**
   * 设置文本颜色
   */
  color: _propTypes["default"].oneOf(["light", "dark", "bright", "primary", "success", "warning", "error", "remark"]),

  /**
   * 设置字号
   */
  size: _propTypes["default"].oneOf(["t1", "t2", "t3", "t4", "t5", "t6", "t7", "t8"]),

  /**
   * 设置行高
   */
  lineHeight: _propTypes["default"].oneOf(["sm", "md", "lg"]),

  /**
   * 添加禁用样式
   */
  disabled: _propTypes["default"].bool,

  /**
   * 添加删除线样式
   */
  deleted: _propTypes["default"].bool,

  /**
   * 是否加粗
   */
  strong: _propTypes["default"].bool,

  /**
   * 添加链接样式
   */
  isLink: _propTypes["default"].bool,

  /**
   * 添加代码样式
   */
  isCode: _propTypes["default"].bool,

  /**
   * 添加数字样式
   */
  isNum: _propTypes["default"].bool,

  /**
   * 设置大小写
   */
  transform: _propTypes["default"].oneOf(["none", "lowercase", "uppercase", "capitalize", "initial"]),

  /**
   * 设置标签类型
   */
  component: _propTypes["default"].elementType,

  /**
   * 自定义类名
   */
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};
Text.defaultProps = {
  disabled: false,
  deleted: false,
  strong: false,
  isLink: false,
  isCode: false,
  isNum: false,
  component: "span"
};
var _default = Text;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/Typography/Text.js
// module id = 1230
// module chunks = 6 7 17 18